import React, { useMemo } from 'react'
import { rem } from 'polished'
import styled from 'styled-components'
import { pluralizeToString } from 'lib/string/pluralize'
import { buildRoomPackageOptionsViewOrder, filterPackageOptionsBySkiPackageType } from 'lib/offer/offerPageUtil'
import { OfferPageState } from 'contexts/OfferPage/offerPageStateReducer'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import { getCheapestSelectedPackageOption, getDurationPackageOptions } from 'selectors/offerPage/offerPageSelectors'
import Group from 'components/utils/Group'
import ModalBody from 'LuxKit/Modal/ModalBody'
import BodyText from 'LuxKit/Typography/BodyText'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import FlashHotelRoomOptionVariantWithCarousel from '../FlashHotelRoomOptionVariantWithCarousel'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Pane from 'components/Common/Pane'
import { InOfferFlowContext } from '../RoomOptionsContext'
import FlashMobileStickyHeaderFilters from '../FlashMobileStickyHeaderFilters'

const OptionsContainer = styled.div`
  padding: ${rem(12)} ${rem(20)};
`

interface Props {
  offer: App.HotelOffer
  packageOptions: Array<App.OfferPackageOptionView>
  onBack?: () => void
  onClose: () => void
  cheapestSelectedOption?: App.OfferPackageOptionView
}

function FlashHotelRoomSelectionModal(props: Props) {
  const {
    offer,
    packageOptions: basePackageOptions,
    onBack,
    onClose,
    cheapestSelectedOption,
  } = props

  // TEMP: Remove this logic when "006RF00000IRdvlYAD" becomes unavailable
  const { packageOptions, skiPackageFiltered } = useMemo(() => {
    return filterPackageOptionsBySkiPackageType(basePackageOptions, cheapestSelectedOption)
  }, [basePackageOptions, cheapestSelectedOption])

  const packageOptionsByRoom = useMemo(() => {
    return buildRoomPackageOptionsViewOrder(packageOptions)
  }, [packageOptions])

  return (
    <>
      <ModalHeader
        title="Select a room"
        onCloseButtonClick={onClose}
        onBackButtonClick={onBack}
      >
        <FlashMobileStickyHeaderFilters />
      </ModalHeader>
      <ModalBody>
        <InOfferFlowContext.Provider value={false}>
          <Group direction="vertical">
            {packageOptionsByRoom.length > 1 && (
              <OptionsContainer>
                <BodyText variant="small" colour="neutral-three">{pluralizeToString('room type', packageOptionsByRoom.length)} available</BodyText>
              </OptionsContainer>
            )}
            <Pane background="neutral-six">
              <VerticalSpacer gap={8}>
                {packageOptionsByRoom.map((item) =>
                  <FlashHotelRoomOptionVariantWithCarousel
                    key={item.roomId}
                    offer={offer}
                    packageViews={item.packageViews}
                    detailsModalMode="room"
                    useSkiDealAvailabilityActions={skiPackageFiltered}
                  />
                )}
              </VerticalSpacer>
            </Pane>
          </Group>
        </InOfferFlowContext.Provider>
      </ModalBody>
    </>
  )
}

export default withOfferPageAndReduxState((state: OfferPageState, appState: App.State) => ({
  offer: state.offer,
  rooms: state.rooms,
  packageOptions: getDurationPackageOptions(state, appState),
  cheapestSelectedOption: getCheapestSelectedPackageOption(appState, state),
}), FlashHotelRoomSelectionModal)
